import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { CardBodyComponent, CardComponent, CardHeaderComponent, ColComponent, ContainerComponent, FormModule, RowComponent } from '@coreui/angular-pro';
import { CommonModule, Location, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ChartjsComponent } from '@coreui/angular-chartjs';
import { DataTablesModule } from 'angular-datatables';
import { VehicleRepairerGraphData } from '../../../models/vehicle-repair.model';
import { VehicleRepairService } from '../../../services/vehicle-repair.service';
import { GlobalDataService } from '../../../services/global-data.service';
import { ActivatedRoute, NavigationEnd, NavigationStart, Params, Router, RouterLink, RouterOutlet } from '@angular/router';
import { IQueryFilterRange } from '../../../models/vehicle-status.model';
import { Subscription } from 'rxjs';
import { VehicleRepairStoreService } from './repairer-downtime.service';
import { DowntimeRepairerDetailComponent } from './downtime-repairer-detail/downtime-repairer-detail.component';
import { RangeFilterComponent } from '../../../components/range-filter/range-filter.component';
import { cilArrowLeft } from '@coreui/icons';
import { IconDirective } from '@coreui/icons-angular';

@Component({
  selector: 'app-repairer-downtime',
  standalone: true,
  imports: [
    ChartjsComponent,
    ContainerComponent,
    RowComponent,
    ColComponent,
    CardComponent,
    CardBodyComponent,
    CommonModule,
    CardHeaderComponent,
    DataTablesModule,
    RouterLink,
    DowntimeRepairerDetailComponent,
    RouterOutlet,
    RangeFilterComponent,
    FormModule,
    IconDirective,
  ],
  providers:[VehicleRepairStoreService],
  templateUrl: './repairer-downtime.component.html',
  styleUrl: './repairer-downtime.component.scss',
})
export class RepairerDowntimeComponent implements OnInit, OnDestroy {

  icons = { cilArrowLeft };
  repairerSummaryData! : any;

  repairerSummaryOptions = {
    scales: {
      y: {
        beginAtZero: true,
        max: 10,
        title: {
          display: true,
          text: 'Days',
        },
      },
      x: {
        title: {
          display: true,
          text: 'Months',
        },
      },
    },
    plugins: {
      legend: {
        display: false, // Hides the legend to match the style in the image
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  rangeSelector: IQueryFilterRange = IQueryFilterRange.ThisYear
  rangeFilterOptions = [
    { value: IQueryFilterRange.Today, label: "Today" },
    { value: IQueryFilterRange.Yesterday, label: "Yesterday" },
    { value: IQueryFilterRange.ThisWeek, label: "This Week" },
  ]



  routeSubscription!: Subscription | undefined;
  routerSubscription!: Subscription | undefined;
  repairerDataSubscription$!: Subscription;

  vehicleRepairData: any[] = [];
  monthsNames: any = [];
  values : number[] = [];
  months : string[] = [];

  departmentId!: string;
  regionId!: string;
  depotId!: string;

  repairersDetailData : any[] | undefined;
  currentRepairerDetail: any = null;
  isRepairerDetailRoute = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private vehicleRepairService: VehicleRepairService,
    private globalData: GlobalDataService,
    private cd: ChangeDetectorRef,
    private vehicleRepairStoreService : VehicleRepairStoreService,
    private _location: Location
  ) {
    this.routeSubscription = this.route.parent?.params.subscribe(res => {
      debugger
      const href = this.router.url;
      this.isRepairerDetailRoute = href.includes('downtime/detail');
      this.onRouteChange(res);

    });

    this.routerSubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // We've finished navigating
        console.log('routerSubscription: NavigationEnd: ', event);
        this.isRepairerDetailRoute = event.url.includes('downtime/detail');
      }

    });
  }

  ngOnInit(): void {
    // this.routeSubscription = this.route.parent?.params.subscribe((res) =>
    //   this.onRouteChange(res));
    this.rangeSelector = this.route.snapshot.queryParams["range"] || "4"


     // Subscribe to the data observables
    this.vehicleRepairStoreService.vehicleRepairDataObservable.subscribe((vehicleRepairerData) => {
      this.repairersDetailData = vehicleRepairerData;
      this.cd.detectChanges();
    })

    // this.vehicleRepairStoreService.VehicleRepairDataDetailObservable.subscribe(currentRepairerDetail =>
    //   {
    //     console.log(currentRepairerDetail)
    //     this.currentRepairerDetail = currentRepairerDetail;
    //     this.cd.detectChanges();
    //   })
    
     this.repairerDataSubscription$ =  this.vehicleRepairStoreService.vehicleRepairDetailData.subscribe(data => { 
      this.currentRepairerDetail = data;
    });
  }


  handleRouteFilterChange($event: any) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        range: $event.currentTarget?.value
      },
      queryParamsHandling: "merge"
    }).then(res => {
      this.onRouteChange(this.route.snapshot.params)
    })
  }

  async onRouteChange(params: Params): Promise<void> {
    console.log(params)
    this.departmentId = params["departmentId"];
    this.regionId = params["regionId"];
    this.depotId = params["depotId"];

    console.log('Repairer downtime onRouteChange: ', this.departmentId, this.regionId, this.depotId);

    // this.isRepairerDetailRoute = true;
    const range = this.route.snapshot.queryParamMap?.get("range")

    // if (!departmentId || departmentId?.length <= 0) {
    //   this.router.navigate(['/']);
    // }

    const _params = this.globalData.generateApiQueryParams({
      range: range as IQueryFilterRange
    });


    this.vehicleRepairService.getVehicleGraph(
      params['departmentId'] as string,
      params['regionId'] as string,
      params['depotId'] as string,
      _params).subscribe((data) => {
      console.log({ vehicleRepairerGraph: data, })
      const {values, months} : {values : any[], months: string[]} =  this.getLastDayOfMonthValues(data);
      this.values = values;
      this.months = months;
      this.repairerSummaryData = {
        labels: this.months,
        datasets: [
          {
            label: 'Average number of days vehicle time spent at repairer',
            data:   this.values, // Example data points for each month
            fill: false, // No fill under the line
            borderColor: '#4DB6AC', // Line color
            tension: 0.4, // Smoothing the line curve
            borderWidth: 3, // Thickness of the line
          },
        ],
      };
      this.cd.detectChanges();
    })


  }

  handleChartRef($chartRef: any) {
    if ($chartRef) {
      setTimeout(() => {
        $chartRef?.update();
      }, 3000);
    }
  }

  navigateToDepotRepairer(event:  any){
    this.router.navigateByUrl(`/department/${this.departmentId}/region/${this.regionId}/depot/${this.depotId}/downtime/detail/${event.target.value}`)
  }

  backClicked() {
    // this.router.navigateByUrl(`/department/${this.departmentId}/region/${this.regionId}/depot/${this.depotId}/downtime/`)
    this._location.back();
  }



   getLastDayOfMonthValues(data: VehicleRepairerGraphData) {
    let result: number[] = [];
    let monthNames: string[] = [];

    for (const monthKey in data) {
        result.push(data[monthKey].average_in_month);
        const monthName = monthKey; // Get the month name
        monthNames.push(monthName);
    }
    return { values: result, months: monthNames };
}

 
  
  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    this.repairerDataSubscription$.unsubscribe();
  }
}


